import * as v from 'valibot'

export const AIToolItemSchema = v.object({
  title: v.string(),
  description: v.optional(v.string()),
  to: v.string(),
  // Absolute URL or public-relative URL, so keep it as string()
  thumbnailUrls: v.optional(v.array(v.string())),
})

export const AIToolsSectionSchema = v.object({
  title: v.string(),
  description: v.optional(v.string()),
  items: v.array(AIToolItemSchema),
})

export const AIToolsLandingDataSchema = v.object({
  title: v.string(),
  description: v.string(),
  newFeature: v.optional(v.string()),
  tools: v.array(AIToolsSectionSchema),
})

// TODO: Move to a more appropriate place
export const AIToolsConfigSchema = v.object({
  landing: AIToolsLandingDataSchema,
})

/** All text fields here expected to be i18n keys. */
export type AIToolsSection = v.InferOutput<typeof AIToolsSectionSchema>
/** All text fields here expected to be i18n keys. */
export type AIToolItem = v.InferOutput<typeof AIToolItemSchema>
/** All text fields here expected to be i18n keys. */
export type AIToolsLandingData = v.InferOutput<typeof AIToolsLandingDataSchema>
/** All text fields here expected to be i18n keys. */
export type AIToolsConfig = v.InferOutput<typeof AIToolsConfigSchema>
